import script from "./DataDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./DataDescription.vue?vue&type=script&setup=true&lang=js"

import "./DataDescription.vue?vue&type=style&index=0&id=386ea622&scoped=true&lang=css"

import exportComponent from "/root/tools-store-ranking-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-386ea622"]])

export default __exports__